import { envValue, isTruthyEnv } from '@helpers/envHelpers';

/** Whether the SSO login page should be shown instead of username/password. */
export function isExternalLoginEnabled(): boolean {
  if (isTruthyEnv('VITE_AUTH0_ENABLED')) {
    return true;
  }

  return isTruthyEnv('VITE_AZURE_LOGIN_ENABLED');
}

/**
 * Whether Azure Entra ID login is active.
 * Softys: follows VITE_AUTH0_ENABLED (unchanged).
 * Azure-only clients (e.g. Mall Plaza): set VITE_AZURE_LOGIN_ENABLED=true.
 */
export function isAzureLoginEnabled(): boolean {
  if (envValue('VITE_AZURE_LOGIN_ENABLED') !== undefined) {
    return isTruthyEnv('VITE_AZURE_LOGIN_ENABLED');
  }

  return isTruthyEnv('VITE_AUTH0_ENABLED');
}
